import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { selectFirstAddress } from '../../store/address/address.selectors'
import { AdDesktopAddress } from '../advertising/InlineDesktopAdBanner'
import { AdMobileBannerAddress } from '../advertising/InlineMobileAdBanner'
import Footer from '../footer/Footer'
import { useScrollContext } from '../genericComponents/ResponsiveScrollableWrapper/ResponsiveScrollableWrapper'
import { withEverySelectorTruthy } from '../utils/react-redux'
import AddressContent from './AddressContent'
import s from './AddressMainContent.less'
import { AddressVdeBanner } from './AddressVdeBanner'
import GeoentitiesAtAddress from './GeoentitiesAtAddress'
import GeoentitiesAtAddressPicker from './GeoentitiesAtAddressPicker'
import BestGeoentitiesAround from './BestGeoentitiesAround'
import AddressBlogLinks from './AddressBlogLinks'
import {
  BEST_GEOENTITIES_SUBCATEGORY_HOTEL,
  BEST_GEOENTITIES_SUBCATEGORY_RESTAURANT,
} from './BestGeoentitiesAround.utils'
import AddressStructuredData from './AddressStructuredData'

const AddressMainContent = () => {
  const address = useSelector(selectFirstAddress) ?? {}
  const { label } = address
  const { scrollTop } = useScrollContext()

  useEffect(() => {
    if (label) scrollTop()
  }, [label])

  return (
    <>
      <div className={s.addressMainContent}>
        <AddressStructuredData />
        <AddressContent address={address} />
        <AdDesktopAddress />
        <AddressVdeBanner />
        <GeoentitiesAtAddress />
        <div>
          {/* div necessary here for css first-child */}
          <BestGeoentitiesAround subcategory={BEST_GEOENTITIES_SUBCATEGORY_HOTEL} />
          <BestGeoentitiesAround subcategory={BEST_GEOENTITIES_SUBCATEGORY_RESTAURANT} />
          <AddressBlogLinks />
        </div>
        <GeoentitiesAtAddressPicker />
        <AdMobileBannerAddress />
      </div>
      <Footer />
    </>
  )
}

export default withEverySelectorTruthy(selectFirstAddress)(AddressMainContent)
